var StringifyingMap = /** @class */ (function () {
    function StringifyingMap(catToString) {
        this.catToString = catToString;
        this.internalMap = new Map();
    }
    StringifyingMap.prototype.set = function (k, v) {
        return this.internalMap.set(this.catToString(k), v);
    };
    StringifyingMap.prototype.get = function (k) {
        return this.internalMap.get(this.catToString(k));
    };
    StringifyingMap.prototype.has = function (k) {
        return this.internalMap.has(this.catToString(k));
    };
    StringifyingMap.prototype.delete = function (k) {
        return this.internalMap.delete(this.catToString(k));
    };
    Object.defineProperty(StringifyingMap.prototype, "size", {
        get: function () {
            return this.internalMap.size;
        },
        enumerable: true,
        configurable: true
    });
    StringifyingMap.prototype.forEach = function (callback, thisArg) {
        this.internalMap.forEach(callback, thisArg);
    };
    return StringifyingMap;
}());
export { StringifyingMap };
